import { useState } from "react";
import { Phone, Menu, X } from "lucide-react";
import { Logo } from "@/components/Logo";

const links = [
  { label: "Services", href: "#services", testid: "header-nav-services" },
  { label: "Service Area", href: "#service-area", testid: "header-nav-service-area" },
  { label: "About", href: "#about", testid: "header-nav-about" },
  { label: "Contact", href: "#booking", testid: "header-nav-contact" },
];

export default function Nav() {
  const [open, setOpen] = useState(false);

  return (
    <div id="top" className="sticky top-0 z-50">
      <div className="bg-navy text-white/90 text-xs sm:text-[13px]">
        <div className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-4 py-2 sm:px-6 lg:px-8">
          <p className="font-mono uppercase tracking-[0.14em]">
            Radon Testing &amp; Mitigation — Est. 2018
          </p>
          <a
            data-testid="header-call-button"
            href="tel:+15089692104"
            className="flex items-center gap-1.5 font-semibold text-gold-light transition-colors hover:text-white"
          >
            <Phone className="h-3.5 w-3.5" />
            (508) 969-2104
          </a>
        </div>
      </div>

      <header className="border-b border-slate-200/80 bg-white/90 shadow-sm backdrop-blur-xl">
        <div className="mx-auto flex max-w-7xl items-center justify-between gap-6 px-4 py-3 sm:px-6 lg:px-8">
          <Logo />

          <nav className="hidden items-center gap-7 lg:flex">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                data-testid={l.testid}
                className="text-sm font-medium text-slate-600 transition-colors hover:text-gold-deep"
              >
                {l.label}
              </a>
            ))}
            <span
              data-testid="header-years-pill"
              className="rounded-full bg-gold/10 px-3 py-1 text-xs font-semibold text-gold-deep ring-1 ring-gold/40"
            >
              8 Years in Business
            </span>
          </nav>

          <div className="flex items-center gap-3">
            <a
              data-testid="header-book-button"
              href="#booking"
              className="hidden rounded-lg bg-navy px-5 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-navy-deep sm:inline-block"
            >
              Book a Radon Test
            </a>
            <button
              data-testid="mobile-menu-button"
              onClick={() => setOpen(!open)}
              className="rounded-lg p-2 text-navy transition-colors hover:bg-slate-100 lg:hidden"
              aria-label="Toggle menu"
            >
              {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
            </button>
          </div>
        </div>

        {open && (
          <div
            data-testid="mobile-menu-panel"
            className="border-t border-slate-200 bg-white px-4 pb-5 pt-3 lg:hidden"
          >
            <div className="flex flex-col gap-1">
              {links.map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  data-testid={`${l.testid}-mobile`}
                  onClick={() => setOpen(false)}
                  className="rounded-lg px-3 py-2.5 text-sm font-medium text-slate-700 transition-colors hover:bg-slate-50 hover:text-gold-deep"
                >
                  {l.label}
                </a>
              ))}
              <a
                data-testid="mobile-book-button"
                href="#booking"
                onClick={() => setOpen(false)}
                className="mt-2 rounded-lg bg-navy px-5 py-3 text-center text-sm font-semibold text-white transition-colors hover:bg-navy-deep"
              >
                Book a Radon Test
              </a>
            </div>
          </div>
        )}
      </header>
    </div>
  );
}
